import { Box, Button, Typography } from '@mui/material';
import React, { ReactNode } from 'react';
import CustomTypography from './CustomTypography';
import IconWarn from '../../assets/icons/IconWarn';

type FinsihedDialogProps = {
  children: ReactNode;
};
const closeWindow = () => {
  window.close();
};

const FinsihedDialog = ({ children }: FinsihedDialogProps) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
      }}
    >
      <Typography variant='h6'>{children}</Typography>
      <Button
        variant='outlined'
        sx={{
          mt: 3, // Adds margin-top for spacing below children
          display: 'flex',
          width: '98px',
          padding: '10px 12px',
          justifyContent: 'center',
          alignItems: 'center',
          gap: '4px',
          borderRadius: '48px',
          border: '1px solid #E3E3E3',
          background: '#FFF',
          '&.Mui-disabled': {
            backgroundColor: 'rgba(0, 0, 0, 0.12)',
            cursor: 'not-allowed',
            pointerEvents: 'all !important', // Override pointer-events: none
          },
        }}
        onClick={closeWindow}
      >
        <Typography
          variant='body1'
          sx={{
            color: '#343330',
            fontFamily: 'Montserrat',
            fontSize: '14px',
            fontStyle: 'normal',
            fontWeight: '500',
            lineHeight: '28px' /* 200% */,
          }}
        >
          Finish
        </Typography>
      </Button>
    </Box>
  );
};

export default FinsihedDialog;
